import _ from "lodash";
import { createSelector } from "reselect";
import { RootState } from "sweet-web/redux";

const s = (state: RootState) => state.search;

export const searchFilters = (state: RootState) => s(state).filters;
export const searchQuery = (state: RootState) => s(state).query;
export const searchResults = (state: RootState) => s(state).results;
export const searchHasResults = (state: RootState) =>
  s(state).results.length > 0;
export const searchFocused = (state: RootState) => s(state).focused;

export const searchFilter = (name: string) =>
  createSelector(searchFilters, filtersValue =>
    filtersValue ? filtersValue[name] : null
  );
